import { __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
import { getAllPersonNodesSchemaObject, getNodeSchemaObject, } from './relationships.schemas';
/*
Client for making Relationships Sevice API calls.
*/
var RelationshipsClient = /** @class */ (function (_super) {
    __extends(RelationshipsClient, _super);
    function RelationshipsClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/tenancy-registry';
        _this.apiVersion = '1';
        _this.personEndpoint = '/person';
        _this.domainsEndpoint = '/domains';
        _this.nodeEndpoint = '/node';
        _this.childrenEndpoint = '/children';
        _this.administersEndpoint = 'administers:crossuses';
        return _this;
    }
    /**
     * Validation schema for getAllNodes
     * @returns Schema object for getAllNodes
     */
    RelationshipsClient.getAllNodesSchema = function () {
        return getAllPersonNodesSchemaObject;
    };
    /**
     * Validation schema for getNode
     * @returns Schema object for getNode
     */
    RelationshipsClient.getNodeSchema = function () {
        return getNodeSchemaObject;
    };
    /**
     * Get the list of domains based on the parameters provided.
     * @param {getAllPersonNodesOptions} options options to get the list of relationships.
     * The documentation states that all search parameters are optional.
     * @returns Axios response object
     */
    RelationshipsClient.prototype.getAllPersonNodes = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: RelationshipsClient.getAllNodesSchema(),
                        url: "".concat(this.personEndpoint).concat(this.domainsEndpoint),
                        params: options,
                    })];
            });
        });
    };
    /**
     * Get node details based on nodeId.
     * @param {getNodeOptions} options options to get node details.
     * nodeId param required.
     * @returns Axios response object
     */
    RelationshipsClient.prototype.getNode = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: RelationshipsClient.getNodeSchema(),
                        url: "".concat(this.nodeEndpoint, "/").concat(options.nodeId),
                    })];
            });
        });
    };
    /**
     * Get child node details based on nodeId.
     * @param {getNodeOptions} options options to get node details.
     * nodeId param required.
     * @returns Axios response object
     */
    RelationshipsClient.prototype.getChildrenNodes = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.nodeEndpoint, "/").concat(options.nodeId).concat(this.childrenEndpoint, "?page=").concat(options.page, "&recursive=").concat(options.isRecursive || false),
                    })];
            });
        });
    };
    /**
     * Get all nodes that this node have implicit admin and use of
     * @param {getNodeOptions} options options to get node details.
     * nodeId param required.
     * @returns Axios response object
     */
    RelationshipsClient.prototype.getNodewithAdministersCrossUses = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.nodeEndpoint, "/").concat(options.nodeId, "/").concat(this.administersEndpoint) +
                            "?page=".concat(options.page, "&size=").concat(options.size),
                    })];
            });
        });
    };
    return RelationshipsClient;
}(StratusClient));
export { RelationshipsClient };
//# sourceMappingURL=relationships.js.map